export const APPCUES_ID = {
    GAUGE_BAR_WRAPPER: 'GAUGE_BAR_WRAPPER',
};
